import { Utils } from "@/utils/index";

export function getFormattedCurrency(value: number) {
  if (!value || typeof value !== "number") return "";
  return Utils.formatPrice(value);
}
